var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("pulse-loader", {
        staticClass: "text-center",
        attrs: {
          loading: _vm.loading.record,
          color: _vm.$constants.LOADING_COLOR,
        },
      }),
      _vm._v(" "),
      !_vm.loading.record
        ? [
            _c(
              "div",
              { staticClass: "mb-1 border-bottom" },
              [
                _c("AddSupplierCodes", {
                  attrs: { task: { object_id: _vm.record003Id } },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }